let stopOnUnloadHandler: ((e: Event) => void) | null = null;

export const registerStopOnUnload = (get: any) => {
  if (typeof window === 'undefined') return;
  if (stopOnUnloadHandler) return;

  stopOnUnloadHandler = () => {
    const { sdk, salesCallStatus } = get();
    if (!sdk || !salesCallStatus?.isActive) return;

    const stopPath = salesCallStatus.callMode === 'simulator' ? '/sales/stop-simulator-call' : '/sales/stop-sale-call';
    const url = `${sdk._cfg.baseURL}${stopPath}`;
    try {
      if (typeof navigator !== 'undefined' && 'sendBeacon' in navigator) {
        const blob = new Blob([""], { type: 'application/json' });
        navigator.sendBeacon(url, blob);
      } else {
        // @ts-ignore keepalive is supported in modern browsers
        fetch(url, {
          method: 'POST',
          credentials: 'include',
          // @ts-ignore
          keepalive: true,
          headers: { 'Content-Type': 'application/json' },
          body: ''
        }).catch(() => { });
      }
    } catch {
      // ignore
    }
  };

  window.addEventListener('beforeunload', stopOnUnloadHandler);
};

export const unregisterStopOnUnload = () => {
  if (typeof window === 'undefined') return;
  if (!stopOnUnloadHandler) return;
  window.removeEventListener('beforeunload', stopOnUnloadHandler);
  stopOnUnloadHandler = null;
};
